import React, { useState } from "react";
import { Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./SelectDate.css";
import ja from "date-fns/locale/ja";
import { ThemeLabel, ThemeInput } from './Controls';

// ロケール登録
registerLocale("ja", ja);

// カスタム入力フィールドのコンポーネント
const CustomInput = React.forwardRef(({ value, onClick, inputId, inputLabel, inputPlaceholder }, ref) => (
  <FormControl variant="standard" fullWidth>
    <ThemeLabel shrink htmlFor={inputId}>{inputLabel}</ThemeLabel>  
    <ThemeInput
      placeholder={inputPlaceholder} 
      id={inputId}
      value={value}
      onClick={onClick}
      readOnly
      ref={ref}
      className={styles.datePicker}
    />
  </FormControl>
));

// displayNameを追加
CustomInput.displayName = "CustomInput";

// カレンダーヘッダ部分
const renderCustomHeader = ({ date, decreaseMonth, increaseMonth }) => {
  const year = new Intl.DateTimeFormat("ja", { year: "numeric" }).format(date);
  const month = new Intl.DateTimeFormat("ja", { month: "long" }).format(date);

  return (
    <div className={styles.customHeader}>
      <button onClick={decreaseMonth}>{`<`}</button>
      <span>{` ${year} ${month} `}</span>
      <button onClick={increaseMonth}>{`>`}</button>
    </div>
  );
};

/**
 * @param selectedDate - 選択された日付と時刻
 * @param onChange - 日付と時刻が変更されたときのコールバック関数
 */
export const SelectDate = (props) => {
  return (
    <FormControl variant="standard" fullWidth>
      <Controller control={props.control} name={props.id} 
        render={({ field }) => (
          <DatePicker
            selected={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            locale="ja"
            dateFormat="yyyy/MM/dd"
            isClearable={true}
            customInput={<CustomInput inputId={props.id} inputLabel={props.label} inputPlaceholder={props.placeholder}/>}
            calendarClassName={styles.customCalendar}
            //renderCustomHeader={renderCustomHeader}
          />
        )}
      />
    </FormControl>
  );
};

/**
 * @param selectedDate - 選択された日付と時刻
 * @param onChange - 日付と時刻が変更されたときのコールバック関数
 */
export const SelectDateRange = (props) => {
  const [start, end] = props.value;

  return (
    <FormControl variant="standard" fullWidth>
      <DatePicker
        selectsRange={true}
        startDate={start}
        endDate={end}
        onChange={(dates) => {
          props.onChange(dates)
        }}
        locale="ja"
        dateFormat="yyyy/MM/dd"
        isClearable={true}
        customInput={<CustomInput inputId={props.id} inputLabel={props.label} inputPlaceholder={props.placeholder}/>}
        calendarClassName={styles.customCalendar}
        //renderCustomHeader={renderCustomHeader}
      />
    </FormControl>
  );
};
